var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-container",
        { staticClass: "customer-service-container" },
        [
          _c(
            "el-aside",
            { staticClass: "aside-menu", attrs: { width: "240px" } },
            [
              _c("div", { staticClass: "menu-header" }, [
                _c("span", [
                  _c("i", { staticClass: "el-icon-chat-dot-round" }),
                  _vm._v(" 客诉")
                ])
              ]),
              _c(
                "el-menu",
                {
                  staticClass: "custom-menu",
                  on: { select: _vm.handleMenuSelect }
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      class: { "active-item": _vm.activeMenu === "processing" },
                      attrs: { index: "processing" }
                    },
                    [
                      _c("span", [_vm._v("正在处理的客诉")]),
                      _vm.unreadStatusData.processing
                        ? _c(
                            "span",
                            {
                              staticClass: "unreadStatus",
                              staticStyle: {
                                color: "#f56c6c",
                                "margin-left": "4px",
                                "font-size": "10px"
                              }
                            },
                            [_vm._v("● ")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "el-menu-item",
                    {
                      class: { "active-item": _vm.activeMenu === "all" },
                      attrs: { index: "all" }
                    },
                    [
                      _c("span", [_vm._v("所有客诉")]),
                      _vm.unreadStatusData.all
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f56c6c",
                                "margin-left": "4px",
                                "font-size": "10px"
                              }
                            },
                            [_vm._v("● ")]
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "el-menu-item",
                    {
                      class: { "active-item": _vm.activeMenu === "new" },
                      attrs: { index: "new" }
                    },
                    [
                      _c("span", [_vm._v("我的新客诉")]),
                      _vm.unreadStatusData.new
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f56c6c",
                                "margin-left": "4px",
                                "font-size": "10px"
                              }
                            },
                            [_vm._v("● ")]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-aside",
            {
              staticClass: "list-panel",
              staticStyle: { overflow: "hidden" },
              attrs: { width: "320px" }
            },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "搜索",
                      clearable: "",
                      "prefix-icon": "el-icon-search",
                      size: "small"
                    },
                    model: {
                      value: _vm.search_name,
                      callback: function($$v) {
                        _vm.search_name = $$v
                      },
                      expression: "search_name"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.getMyConversations(1)
                        }
                      }
                    },
                    [_vm._v("搜索")]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "list-items" }, [
                _c(
                  "div",
                  { staticClass: "list-content-wrapper" },
                  [
                    _vm.sessionList.length === 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              color: "#909399",
                              "margin-top": "40px",
                              "font-size": "13px"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-copy-document",
                              staticStyle: {
                                "font-size": "24px",
                                "margin-bottom": "8px",
                                display: "block"
                              }
                            }),
                            _vm._v(" 暂无分配的玩家会话 ")
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.sessionList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.player_id,
                          staticClass: "complaint-card",
                          class: {
                            selected: item.player_id === _vm.selectedPlayerId
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleActivePlayer(item.player_id)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-header" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "title text-ellipsis",
                                  staticStyle: {
                                    height: "20px",
                                    "line-height": "20px"
                                  },
                                  attrs: { title: item.player_name }
                                },
                                [
                                  _vm._v(
                                    " 【" +
                                      _vm._s(item.game_name) +
                                      "】" +
                                      _vm._s(item.player_name) +
                                      " "
                                  )
                                ]
                              ),
                              item.original
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "mini", type: "warning" }
                                    },
                                    [
                                      _vm._v(
                                        " 来源渠道: " +
                                          _vm._s(
                                            _vm.originalStatus[item.original]
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              item.unread_count > 0
                                ? _c(
                                    "el-tag",
                                    { attrs: { size: "mini", type: "danger" } },
                                    [_vm._v(_vm._s(item.unread_count))]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "card-tags" },
                            [
                              item.server_name
                                ? _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v(" " + _vm._s(item.server_name) + " ")
                                  ])
                                : _vm._e(),
                              item.recharge_amount > 0
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type:
                                          item.recharge_amount / 100 > 1000
                                            ? "danger"
                                            : "info"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "(￥" +
                                            _vm._s(
                                              (
                                                item.recharge_amount / 100
                                              ).toFixed(2)
                                            ) +
                                            ")"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "status-tag",
                                  style:
                                    item.status === "closed"
                                      ? "background: #f4f4f5; color: #909399;"
                                      : "background: #f0f9eb; color: #67c23a;"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.status === "closed"
                                          ? "已断开"
                                          : "沟通中"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _c(
                "div",
                { staticClass: "list-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      layout: "total,sizes, prev, next",
                      "current-page": _vm.searchData.page,
                      total: _vm.total
                    },
                    on: {
                      "size-change": _vm.sizeChange,
                      "current-change": _vm.getMyConversations
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-main",
            { staticClass: "chat-panel" },
            [
              _vm.selectedPlayerId
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "chat-header",
                        staticStyle: {
                          "border-bottom": "1px solid #e6e6e6",
                          padding: "15px 20px"
                        }
                      },
                      [
                        _c("div", { staticClass: "user-info" }, [
                          _c(
                            "span",
                            {
                              staticClass: "username",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "15px"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (
                                      _vm.sessionList.find(function(s) {
                                        return (
                                          s.player_id === _vm.selectedPlayerId
                                        )
                                      }) || {}
                                    ).player_name
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "userid",
                              staticStyle: {
                                color: "#999",
                                "margin-left": "10px",
                                "font-size": "13px"
                              }
                            },
                            [
                              _vm._v(
                                " ID: " + _vm._s(_vm.selectedPlayerId) + " "
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      { ref: "messageBox", staticClass: "chat-messages" },
                      _vm._l(
                        _vm.messageMap[_vm.selectedPlayerId] || [],
                        function(msg, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: [
                                msg.isSelf ? "msg-send" : "msg-receive",
                                "msg-row-item"
                              ],
                              attrs: {
                                "data-id": msg.id,
                                "data-read": msg.read,
                                "data-self": msg.isSelf ? "1" : "0"
                              }
                            },
                            [
                              _c("div", { staticClass: "bubble" }, [
                                msg.content_type == "img"
                                  ? _c(
                                      "div",
                                      { staticClass: "msg-media-container" },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "110px",
                                            height: "110px",
                                            "border-radius": "4px"
                                          },
                                          attrs: {
                                            fit: "contain",
                                            src: msg.content,
                                            "preview-src-list": [msg.content]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : msg.content_type === "video"
                                  ? _c(
                                      "div",
                                      { staticClass: "msg-media-container" },
                                      [
                                        _c("video", {
                                          staticStyle: {
                                            width: "110px",
                                            height: "110px",
                                            "border-radius": "4px"
                                          },
                                          attrs: {
                                            src: msg.content,
                                            controls: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _c("div", [_vm._v(_vm._s(msg.content))]),
                                _c("div", { staticClass: "msg-meta" }, [
                                  msg.status === "sending"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#e6a23c" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-loading"
                                          }),
                                          _vm._v(" 发送中 ")
                                        ]
                                      )
                                    : msg.status == "error"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#f56c6c" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-warning"
                                          }),
                                          _vm._v(" 失败 ")
                                        ]
                                      )
                                    : _vm._e(),
                                  msg.isSelf && msg.read == 0
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#f56c6c",
                                            "margin-right": "4px"
                                          }
                                        },
                                        [_vm._v("● 未读")]
                                      )
                                    : _vm._e(),
                                  msg.isSelf && msg.read == 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#999",
                                            "margin-right": "4px"
                                          }
                                        },
                                        [_vm._v("已读")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(msg.time) + " ")
                                ])
                              ])
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "input-area" },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              { staticClass: "toolbar" },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "top-start",
                                      width: "600",
                                      trigger: "click",
                                      "popper-class": "emoji-popover"
                                    },
                                    model: {
                                      value: _vm.emojiVisible,
                                      callback: function($$v) {
                                        _vm.emojiVisible = $$v
                                      },
                                      expression: "emojiVisible"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "emoji-container" },
                                      _vm._l(_vm.emojiList, function(
                                        emoji,
                                        index
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            key: index,
                                            staticClass: "emoji-item",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleSelectEmoji(
                                                  emoji
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" " + _vm._s(emoji) + " ")]
                                        )
                                      }),
                                      0
                                    ),
                                    _c("el-button", {
                                      staticStyle: {
                                        "font-size": "18px",
                                        color: "#606266",
                                        "margin-left": "15px",
                                        padding: "0"
                                      },
                                      attrs: {
                                        slot: "reference",
                                        type: "text",
                                        icon: "el-icon-dessert",
                                        title: "选择表情"
                                      },
                                      slot: "reference"
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-upload",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "15px"
                                },
                                attrs: {
                                  action: _vm.action,
                                  name: "pic",
                                  "show-file-list": false,
                                  "before-upload": _vm.beforeImageUpload,
                                  "on-success": _vm.upSuccess,
                                  headers: _vm.headers,
                                  accept: "image/*"
                                }
                              },
                              [
                                _c("el-button", {
                                  staticStyle: {
                                    "font-size": "18px",
                                    color: "#606266",
                                    padding: "0"
                                  },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-picture-outline",
                                    title: "发送图片"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-upload",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-left": "15px"
                                },
                                attrs: {
                                  action: _vm.action,
                                  name: "pic",
                                  "on-success": _vm.upVideoSuccess,
                                  "show-file-list": false,
                                  "before-upload": _vm.beforeVideoUpload,
                                  accept: "video/*"
                                }
                              },
                              [
                                _c("el-button", {
                                  staticStyle: {
                                    "font-size": "18px",
                                    color: "#606266",
                                    padding: "0"
                                  },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-video-camera",
                                    title: "发送视频"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("el-input", {
                          ref: "replyInput",
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入回复内容，Enter键发送..."
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.sendMessage("", "text")
                            },
                            paste: function($event) {
                              return _vm.handlePaste($event)
                            }
                          },
                          model: {
                            value: _vm.replyMsg,
                            callback: function($$v) {
                              _vm.replyMsg = $$v
                            },
                            expression: "replyMsg"
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "input-footer" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "primary",
                                  disabled: !_vm.replyMsg.trim()
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sendMessage("", "text")
                                  }
                                }
                              },
                              [_vm._v("回复")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _c(
                    "div",
                    {
                      staticClass: "empty-chat",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "center",
                        "justify-content": "center",
                        height: "100%",
                        color: "#909399"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-chat-line-round",
                        staticStyle: {
                          "font-size": "48px",
                          "margin-bottom": "10px"
                        }
                      }),
                      _c("p", [_vm._v("请在左侧选择一个玩家会话开始沟通")])
                    ]
                  )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }